module.exports = { apiServer: 'https://lc-api.win.eventizer.hk', AdminServer: 'https://lc-admin.win.eventizer.hk', env: 'prod' };
